import { Component, OnInit, OnChanges } from '@angular/core';
import { MenuItem } from 'primeng/api/menuitem';
import { CursosService } from 'src/app/services/cursos.service';
import { AuthService } from 'src/app/_helpers';
import { Router } from '@angular/router';
import { CursoDisponible } from 'src/app/models/curso-disp.model';
import { CursoDetalle } from 'src/app/models/curso-det.model';
import * as moment from 'moment';
import { KeyValueModel } from 'src/app/models/key-value.model';
import { KeyValue } from '@angular/common';
import { MaterialModel } from 'src/app/models/curso-material.model';
import { environment } from 'src/environments/environment';
import { MessageService } from 'primeng/api';
import { CursoInscritoModel } from 'src/app/models/curso-inscrito.model';
import { ExamenList } from 'src/app/models/examen.model';
import { RespuestaUser } from 'src/app/models/respuesta-user.model';
import { Key } from 'protractor';
import { EvaluarExamenModel } from 'src/app/models/EvaluarExamen.model';
import { ResultadoModel } from 'src/app/models/resultado.model';

@Component({
  selector: 'app-curso-inscrito-detalle',
  templateUrl: './curso-inscrito-detalle.component.html',
  styleUrls: ['./curso-inscrito-detalle.component.scss']
})
export class CursoInscritoDetalleComponent implements OnInit, OnChanges {
  items: MenuItem[];
  activeItem: MenuItem;
  materialCurso: MaterialModel[] = [];
  SelMaterialCurso: MaterialModel = <MaterialModel>{};
  codPersona = '';
  codTemaCap = '';
  codCurso = '';
  inscritoDetalle: CursoInscritoModel = <CursoInscritoModel>{};  // popup
  vigenciaOpt: KeyValueModel[] = [];
  empCap: KeyValueModel[] = [];
  verVisor = false;
  verVisorVideo = false;
  totalPreguntas = 0;
  countNPreg = 0;

  urlPdf = '';
  urlVideo = '';
  listaPreguntas: ExamenList[] = [];
  selPregunta: ExamenList = <ExamenList>{};

  selectedValue: string;
  selMultiValue: string[] = [];
  respText = '';
  respuestaUser: RespuestaUser[] = [];
  btnPrevSt = true;
  btnNextSt = false;
  btnFinSt = true;
  evaluarExamen: EvaluarExamenModel<RespuestaUser> = <EvaluarExamenModel<RespuestaUser>>{};
  verResultado = false;
  resultado: ResultadoModel = <ResultadoModel>{};
  tiposOpt: KeyValueModel[] = [];

  verPreguntas = false;
  btnPreg = true;
  cantResp = '';
  hidenNota = false;
  notaPendiente = 0;
  verEnlace = false;
  constructor(
    private cursodetalle: CursosService,
    private authService: AuthService,
    public messageService: MessageService,

    private router: Router

  ) { }

  ngOnInit(): void {
    this.inscritoDetalle = this.cursodetalle.cursoDisp;
    this.codPersona = this.authService.getusuarioJson().codPersona;
    this.codTemaCap = this.cursodetalle.cursoDisp.codTemaCapacita;
    this.codCurso = this.cursodetalle.cursoDisp.codCurso;

    if (!this.inscritoDetalle.enlace || this.inscritoDetalle.enlace === '') {
      this.verEnlace = true;
    }



    this.items = [
      {
        label: 'Datos Generales',
        icon: 'pi pi-fw pi-tag',
        visible: true,
        command: (event?: any) => {
          this.activeItem = this.items[0];
        }
      },
      {
        label: 'Examen de Evaluación',
        icon: 'pi pi-fw pi-file-o',
        visible: true,
        command: (event?: any) => {
          this.activeItem = this.items[1];
        }
      }

    ];
    this.activeItem = this.items[0];

    this.authService.getTabla('VigenciaCapacita').forEach(value => {
      this.vigenciaOpt.push(new KeyValueModel(value.codRegistro, value.descripcion, ''));
    });

    this.authService.getTabla('EmpresaCapacita').forEach(value => {
      this.empCap.push(new KeyValueModel(value.codRegistro, value.descripcion, ''));
    });

    this.authService.getTabla('TipoCurso').forEach(value => {
      this.tiposOpt.push(new KeyValueModel(value.codRegistro, value.descripcion, ''));
    });


    // this.cursodetalle.getCursoDisponible(this.codPersona, this.codTemaCap).subscribe(
    //   data => {
    //     this.inscritoDetalle = data

    //     console.log('cursoinscritodetalle', data);
    //   }
    // );

    this.getTMaterial();
    this.getListaPreguntas();


  }
  ngOnChanges() {
  }

  getListaPreguntas() {
    // listaPreguntas
    this.cursodetalle.getPreguntasCurso(this.codCurso).subscribe(
      data => {
        this.listaPreguntas = data['data'];
        this.selPregunta = this.listaPreguntas[0];
        this.totalPreguntas = data['count'];
        this.respuestaUser = [];
        console.log('lista preguntas', this.listaPreguntas, this.selPregunta);
        this.hidenNota = false;



        for (const respuesta of this.listaPreguntas) {
          this.respuestaUser.push(new RespuestaUser(respuesta.codPregunta, respuesta.tipo, ''));
          console.log('resp', respuesta.respuesta);
          if (respuesta.countRespuestas === 0) {
            this.hidenNota = true;
            this.notaPendiente = this.notaPendiente + respuesta.puntaje;
            console.log('respuesta ');

          }

        }
        console.log('rpta', this.respuestaUser);


      }, error => {
        console.log('Error', error);
      }
    );
  }

  getTMaterial() {
    this.cursodetalle.getMaterialCurso(this.codCurso, this.codPersona, 'TCAP').subscribe(
      data => {

        this.materialCurso = data['data'];
        this.btnPreg = false;

        console.log('material', this.materialCurso);

        for (const iterator of this.materialCurso) {
          if ((!iterator.revisado || iterator.revisado === 1) && this.inscritoDetalle.intentos < 2) {
            // this.items[1].visible = true;
            console.log('todo revisado');
            this.btnPreg = true;
          }
        }
      }, error => {
        console.log('Error', error);
      }
    );
  }


  descargarMaterial(Material) {
    console.log(Material);
    this.SelMaterialCurso = Material;
      // `${environment.apiPlan}Accion/File/CreateValFiles` + '?nroDocReferencia=' + Material.nroDocReferencia   + '&codPersona=' + this.codPersona + '&codArchivo=' + Material.correlativoArchivos
    var url = `https://antapaccay.sam.glencore.net/HSEC_Web/WHSEC_Service/api/media/openFile/${Material.nroDocReferencia}-${this.codPersona}-${Material.correlativoArchivos}/${Material.nombre}`;

    if (Material.tipoArchivo === 'application/pdf') {      
      this.AbrirPdf(url);
    } else if (Material.tipoArchivo === 'video/mp4') {
      this.AbrirVideo(url);
    }


  }




  formatoFecha(fecha: string) {
    return moment(new Date(fecha)).format('DD/MM/YYYY');
  }


  getVigencia(code) {
    // console.log('VIGENCIA', code, this.vigenciaOpt);
    if (code && code !== '') {
      return this.vigenciaOpt.filter(val => val.Key === code)[0].Value;
    }

  }

  getEmpresa(code) {
    // console.log('Empresa', code, this.vigenciaOpt);
    if (code && code !== '') {
      return this.empCap.filter(val => val.Key === code)[0].Value;
    }

  }


  AbrirPdf(url: string) {
    // this.router.navigateByUrl("/VerDocumento");
    this.urlPdf = url;
    this.verVisor = true;
    // this.getEstadoPdf('completo');

  }

  AbrirVideo(url: string) {
    this.urlVideo = url;
    this.verVisorVideo = true;
  }

  getEstadoVideo(estado) {
    if (estado === 'completo') {
      console.log(estado);
      this.cambiarEstado();
    }
  }
  getEstadoPdf(estado) {
    if (estado === 'completo') {
      console.log(estado);
      this.cambiarEstado();
      this.verVisor = false;

    }
  }

  cambiarEstado() {
    this.cursodetalle.cambiarEstadoArchivo({
      nroDocReferencia: this.SelMaterialCurso.nroDocReferencia, codPersona: this.codPersona,
      codArchivo: this.SelMaterialCurso.correlativoArchivos
    }).subscribe(
      data => {
        this.getTMaterial();

        // this.messageService.add({
        //   severity: "success",
        //   summary: "Archivo revisado",
        //   // detail: "Id de la Observación:" + data
        // });

      }, error => {
        console.log('Error', error);
      }
    );
  }




  getRevisado(estado: number) {
    if (estado === 2) {
      return 'SI';
    } else {
      return 'NO';
    }
  }



  readableBytes(bytes) {
    var i = Math.floor(Math.log(bytes) / Math.log(1024)),
      sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    return +(bytes / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + sizes[i];
  }




  antPregunta() {
    console.log(this.countNPreg + 1);
    this.btnNextSt = false;
    if (this.countNPreg - 1 < 1) {
      this.btnPrevSt = true;
    } else {
      this.btnPrevSt = false;
      this.btnFinSt = true;
    }

    this.countNPreg = this.countNPreg - 1;
    this.selPregunta = this.listaPreguntas[this.countNPreg];

    // if (this.selPregunta.tipo === '1' || this.selPregunta.tipo === '2') {
    //   document.getElementById('dest12').innerHTML = ' ' + this.selPregunta.descripcion;
    // } else if(this.selPregunta.tipo === '3'){
    //   document.getElementById('dest12').innerHTML = ' ' + this.selPregunta.descripcion;
    // }



    this.recoveryPreg(this.respuestaUser[this.countNPreg].tipo, this.respuestaUser[this.countNPreg].respuesta);
    console.log('anterior', this.respuestaUser[this.countNPreg].respuesta);


    // this.respuestaUser
  }


  SigPregunta() {
    // console.log(this.countNPreg + 1, this.totalPreguntas);
    this.btnPrevSt = false;
    if ((this.countNPreg + 1) < this.totalPreguntas - 1) {
      this.btnNextSt = false;
    } else {
      this.btnNextSt = true;
      this.btnFinSt = false;


    }

    this.countNPreg = this.countNPreg + 1;
    this.selPregunta = this.listaPreguntas[this.countNPreg];

    // if (this.selPregunta.tipo === '1' || this.selPregunta.tipo === '2') {
    //   document.getElementById('dest12').innerHTML = ' ' + this.selPregunta.descripcion;
    // } else if(this.selPregunta.tipo === '3'){
    //   document.getElementById('dest12').innerHTML = ' ' + this.selPregunta.descripcion;
    // }


    this.recoveryPreg(this.respuestaUser[this.countNPreg].tipo, this.respuestaUser[this.countNPreg].respuesta);
    console.log('anterior', this.respuestaUser[this.countNPreg].respuesta);

  }


  recoveryPreg(tipo: string, respUser: string) {
    if (tipo === '1') {
      this.selectedValue = respUser;
    } else if (tipo === '2') {
      if (respUser === '') {
        this.selMultiValue = [];
      } else {
        // this.selMultiValue = [];
        this.selMultiValue = respUser.split(';');
        console.log('recovery', this.selMultiValue);
      }
      console.log('respml', this.selMultiValue, respUser);


    } else if (tipo === '3') {

      this.respText = respUser;
    }

  }


  simpleChange() {
    console.log('simple change', this.selectedValue);
    this.respuestaUser[this.countNPreg].respuesta = this.selectedValue;

  }

  multiChange() {
    console.log('multi change', this.selMultiValue);
    this.respuestaUser[this.countNPreg].respuesta = this.selMultiValue.join(';');   ///toString().replace('\,', ';');

  }

  completaChange() {
    console.log('multi change');

    this.respuestaUser[this.countNPreg].respuesta = this.respText;

  }

  FinalizarExamen() {

    this.evaluarExamen.data = this.respuestaUser;
    this.evaluarExamen.codCurso = this.codCurso;
    this.evaluarExamen.codPersona = this.codPersona;
    console.log(this.evaluarExamen);


    this.cursodetalle.evaluarExamen(this.evaluarExamen).subscribe(
      data => {
        this.resultado = data;
        this.verResultado = true;
        this.hidenNota = true;
        console.log('respuesta', this.resultado);

        if (this.resultado.estadoEvaluacion === 'Aprobado' && this.resultado.nota >= (this.resultado.porcentajeEval*this.resultado.puntajeTotal/100)) {
          this.hidenNota = false;
        }

      }, error => {
        console.log('Error', error);
      }
    );

  }

  AceptarResultado() {
    this.verResultado = false;
    this.activeItem = this.items[0];
    this.selectedValue = '';
    this.selMultiValue = [];
    this.respText = '';
    this.getListaPreguntas();

    this.btnPrevSt = true;
    this.btnNextSt = false;
    this.btnFinSt = true;
    this.countNPreg = 0;
    this.verPreguntas = false;
    this.router.navigateByUrl("/CursosInscrito");


  }
  EnviarCertificado() {
    this.verResultado = false;
    this.activeItem = this.items[0];
    this.selectedValue = '';
    this.selMultiValue = [];
    this.respText = '';
    this.getListaPreguntas();

    this.btnPrevSt = true;
    this.btnNextSt = false;
    this.btnFinSt = true;
    this.countNPreg = 0;
    this.verPreguntas = false;
    // servicio enviar certificado
    // this.router.navigateByUrl("/Capacitaciones");

    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', 'https://antapaccay.sam.glencore.net/MHSEC_web/MHSEC_Cap/api/Capacitaciones/Participante/Certificado/'+this.codPersona+'/'+ this.codCurso);
    link.setAttribute('download', `certificado.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();

    this.router.navigateByUrl("/CursosInscrito");





  }


  getDesTipo(code: string) {

    if (code && code !== '') {
      return this.tiposOpt.filter(tipo => +tipo.Key === +code)[0].Value;
    } else {
      return null;
    }
  }


  getDuracionCurso(fecInicio: string, fecFin: string) {
    const inicio = new Date(fecInicio);
    const fin = new Date(fecFin);

    if (fin >= inicio) {
      const fecha1 = moment(inicio, "YYYY-MM-DD HH:mm:ss");
      const fecha2 = moment(fin, "YYYY-MM-DD HH:mm:ss");
      const hora = fecha2.diff(fecha1, 'h'); // Diff in days
      const minuto = fecha2.diff(fecha1, 'm') - hora * 60; // Diff in hours
      return hora + ':' + minuto;

    } else {
      return null;
    }
  }

  empezarExamen() {
    this.verPreguntas = true;
    // for (const respuesta of this.listaPreguntas) {

    // if (this.listaPreguntas[0].tipo === '1' || this.listaPreguntas[0].tipo === '2') {
    //   document.getElementById('dest12').innerHTML = ' ' + this.listaPreguntas[0].descripcion;
    // } else {
    //   document.getElementById('dest12').innerHTML = ' ' + this.listaPreguntas[0].descripcion;
    // }

    // }


  }


}
